import React, { Component, lazy, Suspense } from 'react';
import Layout from './components/Layout/Layout.jsx';
import BurgerBuilder from './containers/BurgerBuilder/BurgerBuilder';
import classes from './App.css';
//import Checkout from './containers/Checkout/Checkout';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
//import Orders from './containers/Orders/Orders';
import ContactData from './containers/Contact_form/ContactData';
//import Auth from './containers/Auth/Auth';
import Logout from './containers/Auth/Logout/Logout';
import {autoSignIn} from './store/actions/auth.js'
import { connect } from 'react-redux';


const Orders = lazy(() => import('./containers/Orders/Orders'));
const Checkout = lazy(() => import('./containers/Checkout/Checkout'));
const Auth = lazy(() => import('./containers/Auth/Auth'));


export class App extends Component {
  componentDidMount(){
    this.props.autoSignIn();
  }
  
  render(){
    let protectedRoutes = null;


     if(this.props.isAuthenticated){
      protectedRoutes = (
          <Switch>
          <Suspense fallback={<div>loading....</div>}>
            <Route path='/orders' exact render={()=> <Orders />}/>
            <Route path='/checkout' exact render={()=> <Checkout />}/>
            <Route path='/checkout/contact-data' exact component={ContactData}/>
          </Suspense>
          <Redirect to='/' />
          </Switch>
        )
     }
    return(   
        <div className={classes.App}>
        <Layout>
          <Route path='/' exact component={BurgerBuilder}/>
          {protectedRoutes}
          <Suspense fallback={<div>loading...</div>}>
            <Route path='/auth' exact render={() => <Auth/> }/>
          </Suspense>
          <Route path='/logout' excat component={Logout}/>
        </Layout>
        </div>

      );

  }
 
}

const mapStateToProps = state =>{
  return {
    isAuthenticated: state.auth.token !== null
  }
}
const mapDispatchToProps = dispatch =>{
  return {
    autoSignIn: () => dispatch(autoSignIn())
  }
}



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js